import axios from 'axios';
import React, {useState, useEffect, useRef} from 'react';
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import "../../../index.css";
import { url, url3 } from '../../../Config';
import Box from "@mui/material/Box";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from "@mui/material/IconButton";



export default function Fs(props) {
    const [apidata, setapidata] = useState([]);
    const [group, setgroup] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState();
    const [mainsector, setmainsector] = useState([]);
    const [selectedMainSector, setselectedMainSector] = useState([]);
    const [sector, setsector] = useState([]);
    const [selectedSector, setselectedSector] = useState([]);
    const [scale, setscale] = useState([]);
    const [selectedScale, setselectedScale] = useState([]);
    const [opinion, setopinion] = useState([]);
    const [selectedOpinion, setselectedOpinion] = useState([]);
    const [period, setperiod] = useState([]);
    const [selectedPeriod, setselectedPeriod] = useState([]);
    const [period_data, setperiod_data] = useState({});
    const [singleperiod_data, setsingleperiod_data] = useState([]);
    const [periodtitle, setperiodtitle] = useState([]);
    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();
    
    const [opinionarr, setopinionarr] = useState([]);
    const [comparisondata, setcomparisondata] = useState([]);
    const [periodlabel, setperiodlabel] = useState([]);
    const [COLUMN_WIDTH, setCOLUMN_WIDTH] = useState(300);
    const  [loading, setloading] = useState("loading");
    const [newperiod2, setnewperiod2] = useState([]);
    const [newopinion, setnewopinion] = useState([]);
    const [sectionlength, setsectionlength] = useState(Array(comparisondata.length * periodlabel.length).fill(null));
    const [bool, setbool] = useState(false);
    const [scale_opinion, setscale_opinion] = useState([]);
    const [showFilters, setShowFilters] = useState(true);
    const [pacra, setpacra] = useState(0);
    const [other, setother] = useState(0);
    const [vis, setvis] = useState(0);
    const [hiddenPeriods, setHiddenPeriods] = useState({});
    const inputRef = useRef(null);
    

        const func = async ()=>{

          setloading("loading");
            const res = await axios.get(`https://209.97.168.200/pacrawizpackv3/public/get-fs-data`);
            let resp = res.data;

            const resultMap = new Map();

            for (const item of resp) {
              const existing = resultMap.get(item.opinion_id);
              if (!existing || item.record_id > existing.record_id) {
                resultMap.set(item.opinion_id, item);
              }
            }

            resp = Array.from(resultMap.values());


            const res2 = await axios.get(`${url3}/api/get_research_new_period`)
            const resp2 = res2.data.data;
            const resp3 = res2.data.otherop;

            for(let  i in  resp){
              resp[i].opinion = 'PACRA';
              for(let j in resp2){
                if(`${resp[i].opinion_id}` == resp2[j].opinion_id){
                  let period = resp2[j].period_name;
                  period = period.replace(' ', '  ');
                  resp[i].data[period] = resp2[j].data;
                }
              }
            }

            for(let i in resp3){
                resp3[i].opinion_id = resp3[i].id2;
                resp3[i].data = {};
                for(let j in resp2){
                if(resp3[i].id2 == resp2[j].opinion_id){
                  let period = resp2[j].period_name;
                  period = period.replace(' ', '  ');
                  resp3[i].group = resp2[j].group;
                  resp3[i].main_sector = resp2[j].main_sector;
                  resp3[i].sector = resp2[j].sector;
                  resp3[i].scale = "Entity";
                  resp3[i].opinion = resp2[j].opinion_of;
                  resp3[i].data[period] = resp2[j].data;
                }

                }
            }

            const merged = [...resp, ...resp3];

            setapidata(merged);

            const seen = new Set();
            const uniquegroupArray = [];
            
            merged.forEach(item => {
                const groupvar = item.group;
                if (groupvar && groupvar !== null && groupvar.trim() !== '') {
                    const groupLower = groupvar.toLowerCase();
                    if (!seen.has(groupLower)) {
                    seen.add(groupLower);
                    uniquegroupArray.push({
                        value: uuidv4(),
                        label: groupvar
                    });
                    }
                }
                });


            setgroup(uniquegroupArray);
            setloading("loaded");
            
        }

    useEffect(()=>{
        func();
    },[])


  const togglePeriod = (opinionName, period) => {
      setHiddenPeriods(prev => {
          const currentHidden = prev[opinionName] || [];

          if (currentHidden.includes(period)) {
              return {
                  ...prev,
                  [opinionName]: currentHidden.filter(p => p !== period)
              };
          }

          return {
              ...prev,
              [opinionName]: [...currentHidden, period]
          };
      });
  };

  const getVisiblePeriods = (opinionName) => {
      const hidden = hiddenPeriods[opinionName] || [];

      return periodlabel.filter(period => !hidden.includes(period));
  };

  const isPeriodHidden = (opinionName, period) => {
      return (hiddenPeriods[opinionName] || []).includes(period);
  };



    const handleSelect = (data)=>{

    setalertOpen(false);
    setSelectedGroup(data);

    setmainsector([]);
    setselectedMainSector([]);
    setscale([]);
    setselectedScale([]);
    setsector([]);
    setselectedSector([]);
    setopinion([]);
    setselectedOpinion([]);
    setperiod([]);
    setselectedPeriod([]);
    setperiodlabel([]);
        const arr = [];
        for(let i in apidata){
            if(apidata[i].group == data.label){
                arr.push(apidata[i]);
            }
        }

         const seen = new Set();
         const uniquemainsectorArray = [];


        arr.forEach(item => {
                const mainsectorvar = item.main_sector;
                if (mainsectorvar && mainsectorvar !== null && mainsectorvar.trim() !== '') {
                    const mainsectorLower = mainsectorvar.toLowerCase();
                    if (!seen.has(mainsectorLower)) {
                    seen.add(mainsectorLower);
                    uniquemainsectorArray.push({
                        value: mainsectorvar,
                        label: mainsectorvar
                    });
                    }
                }
            });

        setmainsector(uniquemainsectorArray);
    }


    const handleSelect2 = (data)=>{

        setalertOpen(false);
        setselectedMainSector(data);

        setsector([]);
        setselectedSector([]);
        setscale([]);
        setselectedScale([]);
        setopinion([]);
        setselectedOpinion([]);
        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);


        const arr = [];
        for(let i in apidata){
            if(apidata[i].main_sector == data.label){
                arr.push(apidata[i]);
            }
        }

         const seen = new Set();
         const uniquesectorArray = [];


        arr.forEach(item => {
                const sectorvar = item.sector;
                if (sectorvar && sectorvar !== null && sectorvar.trim() !== '') {
                    const sectorLower = sectorvar.toLowerCase();
                    if (!seen.has(sectorLower)) {
                    seen.add(sectorLower);
                    uniquesectorArray.push({
                        value: sectorvar,
                        label: sectorvar
                    });
                    }
                }
                });

        setsector(uniquesectorArray);
    }


    const handleSelect3 = (data)=>{

        setalertOpen(false);
        setselectedSector(data);
        setscale([]);
        setselectedScale([]);
        setopinion([]);
        setselectedOpinion([]);
        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);


        const arr = [];
        for(let i in apidata){
            if(apidata[i].sector == data.label){
                arr.push(apidata[i]);
            }
        }

        console.log(arr, "arr")
        setscale_opinion(arr);

         const seen = new Set();
         const uniquescaleArray = [];
        //  uniqueopinionArray.push({ value: '*', label: 'Select All' });

          arr.forEach(item => {
                const scalevar = item.scale;
                if (scalevar && scalevar !== null && scalevar.trim() !== '') {
                    const scaleLower = scalevar.toLowerCase();
                    if (!seen.has(scaleLower)) {
                    seen.add(scaleLower);
                    uniquescaleArray.push({
                        value: scalevar,
                        label: scalevar
                    });
                    }
                }
                });


        
        setscale(uniquescaleArray);

    }

    const handleSelect4 = (data)=>{

       setalertOpen(false);
       setselectedScale(data);

        setopinion([]);
        setselectedOpinion([]);
        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);


        const arr = [];
        console.log(scale_opinion, "scale_opinion")
        for(let i in data){
          for(let j in scale_opinion){
              if(scale_opinion[j].scale == data[i].label){
                  arr.push(scale_opinion[j]);
              }
          }
        }

        

         const seen = new Set();
         const uniqueopinionArray = [];
         const uniqueopinionArray2 = [];
         uniqueopinionArray.push({ value: '*', label: 'Select All' });


        arr.forEach(item => {
                const opinionvar = item.opinion_name;
                const opinionof = item.opinion;
                let recordid = null;
                if(item.record_id !== undefined){
                  recordid = item.record_id;
                }
                else{
                  if(item.opinion_of == "VIS" || item.opinion_of == "Other"){
                    recordid = item.id2;
                  }
                }
                if (opinionvar && opinionvar !== null && opinionvar.trim() !== '') {
                    const opinionLower = opinionvar.toLowerCase();
                    if (!seen.has(opinionLower)) {
                    seen.add(opinionLower);
                    uniqueopinionArray.push({
                        value: recordid,
                        label: opinionvar
                    });
                    uniqueopinionArray2.push({
                        recordid: recordid,
                        name: opinionvar,
                        opinionof: opinionof

                    });
                    }
                }
        });

        uniqueopinionArray.sort((a, b) => {
            if (a.label === 'Select All') return -1; // Always keep 'Select All' at the top
            if (b.label === 'Select All') return 1;
            return a.label.localeCompare(b.label);   // Sort remaining alphabetically
        });
        const counts = uniqueopinionArray2.reduce((acc, item) => {
          acc[item.opinionof] = (acc[item.opinionof] || 0) + 1;
          return acc;
        }, {});

        setpacra(counts.PACRA || 0);
        setother(counts.Other || 0);
        setvis(counts.VIS || 0);
       
        setopinion(uniqueopinionArray);

    }

    // Utility to extract Date object from label like "Sep-24  3M"
    function extractDate(str) {
    const match = str.match(/([A-Za-z]{3})-(\d{2})/); // e.g., ["Sep-24", "Sep", "24"]
    if (!match) return new Date(0); // fallback
    const [_, monthStr, yearStr] = match;
    const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].indexOf(monthStr);
    const year = parseInt(yearStr, 10) + 2000;
    return new Date(year, month);
    }

    const handleSelect5 = (data)=>{

       setalertOpen(false); 
      
       setnewopinion(data);
         if (!data) {
            setselectedOpinion([]);
            setperiod([]);
            setselectedPeriod([]);
            setperiodlabel([]);
            return;
        }

        let newdata = [];

         const isSelectAllSelected = data.some(opt => opt.value === '*');
         const isCurrentlyAllSelected = selectedOpinion.length === opinion.length - 1;

        if (isSelectAllSelected && !isCurrentlyAllSelected) {
            // Select all real options (excluding 'Select All')
            setselectedOpinion(opinion.filter(opt => opt.value !== '*'));
            newdata = opinion.filter(opt => opt.value !== '*');
        } else if (isSelectAllSelected && isCurrentlyAllSelected) {
            // Deselect all
            setselectedOpinion([]);
            
        } else {
            // Normal selection
            newdata = data.filter(opt => opt.value !== '*');
            setselectedOpinion(data.filter(opt => opt.value !== '*'));
        }

        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);

        // setselectedOpinion(data);

        const arr = [];
        const keys = [];
        const perioddataarr = [];
        const opinionarr2 = [];

        for(let i in newdata){
            keys.push(newdata[i].label)
        }

        for(let i in newdata){
            for(let j in apidata){
                if(apidata[j].opinion_name == newdata[i].label){
                    const key = Object.keys(apidata[j].data);
                    arr.push(key);
                    perioddataarr.push(apidata[j].data)
                    opinionarr2.push({opinion_name: apidata[j].opinion_name, opinion_id: apidata[j].opinion_id, opinion: apidata[j].opinion, legal_status: apidata[j].legal_status});
                    // for(let i in key){
                    //     arr.push({value:uuidv4(), label: key[i]});
                    // }
                    // setperiod(arr);
                    // setperiod_data(apidata[i].data);
                   
                }
            }
        }

        setopinionarr(opinionarr2);
        setperiod_data(perioddataarr);
        console.log(perioddataarr, 'perioddataarr');

        if(!arr.length){
            return;
        }
        console.log(arr,  "arr");

        // console.log(arr[0], 'arr');
        // let commonSet = new Set(arr[0]);

        // // Intersect with the rest of the subarrays
        // for (let i = 1; i < arr.length; i++) {
        //     commonSet = new Set(arr[i].filter(item => commonSet.has(item)));
        // }
        // // Convert Set to Array (preserves order of last intersection)
        // // return Array.from(commonSet);
        // const commonarr = Array.from(commonSet);

        // console.log(commonarr, 'common')

        const rawResult = [...new Set(arr.flat())];

        // let arrfinal = [];
        // for(let i in commonarr){
        //     arrfinal.push({value:uuidv4(), label: commonarr[i]});
        // }
        // for(let i in result){
        //     arrfinal.push({value:uuidv4(), label: result[i]});
        // }

        // Step 1: Sort descending
        const sorted = [...rawResult].sort((a, b) => extractDate(b) - extractDate(a));

        // Step 2: Mark the first one (latest) with highlight
        const latest = sorted[0];

        const arrfinal = sorted.map(label => ({
        value: uuidv4(),
        label,
        highlight: label === latest
        }));
    


            const selectAllOption = { value: '*', label: 'Select All' };
             setperiod([selectAllOption, ...arrfinal]);



        // setperiod(arrfinal);

    }

    const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: state.data.highlight ? 'red' : provided.color
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.data.highlight ? 'red' : provided.color
    }),
    menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Very high to appear on top
  }),
  };

  const customSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // Very high to appear on top
  }),
};

    const handleSelect6 = (data)=>{
        
        // setselectedPeriod(data);

        setalertOpen(false);
        setnewperiod2(data);


        let newdata = [];

         const isSelectAllSelected = data.some(opt => opt.value === '*');
         const isCurrentlyAllSelected = selectedPeriod.length === period.length - 1;

        if (isSelectAllSelected && !isCurrentlyAllSelected) {
            // Select all real options (excluding 'Select All')
            setselectedPeriod(period.filter(opt => opt.value !== '*'));
            newdata = period.filter(opt => opt.value !== '*');
        } else if (isSelectAllSelected && isCurrentlyAllSelected) {
            // Deselect all
            setselectedPeriod([]);
            
        } else {
            // Normal selection
            newdata = data.filter(opt => opt.value !== '*');
            setselectedPeriod(data.filter(opt => opt.value !== '*'));
        }


        let keys = [];

        for(let i in newdata){
                keys.push(newdata[i].label)
        }
        setperiodtitle(keys);

        let newperiod_data = period_data;

        const allKeys = new Set();
        for (const item of newperiod_data) {
            Object.keys(item).forEach((key) => allKeys.add(key));
        }

        // Step 2: Build a template for each key using the fullest version
        const templates = {};

        for (const key of allKeys) {
            for (const item of newperiod_data) {
            if (item[key]) {
                templates[key] = item[key]; // just store one as the base template
                break;
            }
            }
        }

        // Step 3: Helper to clone the structure with default 0s
        const createBlankFromTemplate = (template) => {
            const blank = [];
            let currentSection = null;

            for (const row of template) {
            if (row.length === 1) {
                currentSection = row[0];
                blank.push([currentSection]);
            } else {
                const [id, val] = row;
                const isEmptyString = val === '';
                blank.push([id, isEmptyString ? '' : 0]);
            }
            }

            return blank;
        };

        

        // Step 4: Fill in missing arrays with blanks
        const normalized = newperiod_data.map((item) => {
            const newItem = { ...item };
            for (const key of allKeys) {
            if (!newItem[key]) {
                newItem[key] = createBlankFromTemplate(templates[key]);
            }
            }
            return newItem;
        });

        const arraybasedonOP = [];

        for(let i in opinionarr){
            const result2 = [];

            const sectionMap = new Map(); // Keeps ordered sections and row IDs per section
            const lookups = []; // Lookup tables for each key/array

            setperiodlabel(keys);


            for (const key of keys) {
                let currentArray = normalized[i][key];
                 // 🧼 Clean unnecessary header row like ["", "Audited"]
                if (currentArray.length > 0 && currentArray[0][0] === '') {
                    currentArray = currentArray.slice(1);
                }
                const map = {};
                let currentSection = null;

                for (const row of currentArray) {
                    if (row.length === 1) {
                    currentSection = row[0];
                    if (!sectionMap.has(currentSection)) {
                        sectionMap.set(currentSection, []);
                    }
                    } else {
                    const [id, val] = row;
                    if(sectionMap.get(currentSection) !== undefined ){
                      if (!sectionMap.get(currentSection).includes(id)) {
                          sectionMap.get(currentSection).push(id);
                      }
                    }
                    map[id] = map[id] || {};
                    map[id][currentSection] = val;
                    }
                }

                lookups.push(map);
                }

                // Step 2: Build result2 from sectionMap and lookups
                for (const [section, ids] of sectionMap.entries()) {
                result2.push([section]); // Push section header like ['A']

                for (const id of ids) {
                    const row = [id];
                    for (const map of lookups) {
                    if (map[id] && section in map[id]) {
                        row.push(map[id][section]); // can be '', number, etc.
                    } else {
                        row.push(0); // Only insert 0 if missing completely
                    }
                    }
                    result2.push(row);
                }
                }

                // console.log(result2, 'result');
                arraybasedonOP.push({name: opinionarr[i].opinion_name, data: result2, opinion_id: opinionarr[i].opinion_id,opinion: opinionarr[i].opinion, legal_status: opinionarr[i].legal_status});



            }

            let opinioncompilation = arraybasedonOP;

            let reference = opinioncompilation.reduce((max, curr) =>
                curr.data.length > max.data.length ? curr : max
            );

            const template = reference.data;

            // Step 2: Normalize each opinion to match the reference structure
            for (const opinion of opinioncompilation) {
                if (opinion === reference) continue; // Skip the reference itself

                const rowMap = new Map(); // Map section:id => row
                let currentSection = null;

                for (const row of opinion.data) {
                if (row.length === 1) {
                    currentSection = row[0];
                } else {
                    rowMap.set(`${currentSection}:${row[0]}`, row);
                }
                }

                const normalized = [];
                let currentTemplateSection = null;

                for (const row of template) {
                if (row.length === 1) {
                    currentTemplateSection = row[0];
                    normalized.push([currentTemplateSection]);
                } else {
                    const key = `${currentTemplateSection}:${row[0]}`;
                    const original = rowMap.get(key);

                    if (original) {
                    normalized.push(original);
                    } else {
                    // Create empty row with correct column count
                    const columnCount = row.length;
                    normalized.push([row[0], ...Array(columnCount - 1).fill(0)]);
                    }
                }
                }

                opinion.data = normalized;
            }

            //   return opinioncompilation;


   
            setcomparisondata(opinioncompilation);
    // setsingleperiod_data(result);
    }

    // Extract structure from the most complete opinion
        const template =
        comparisondata.length > 0
            ? comparisondata.reduce((a, b) =>
                a.data.length > b.data.length ? a : b
            ).data
            : [];


function normalizeValue(val) {
  if (!val || val === 'NA' || val === 'N/A') return 0;

  if (typeof val === 'string') {
    if (val.includes('%')) 
      return Math.round(parseFloat(val.replace('%', '')));

    if (val.startsWith('(') && val.endsWith(')')) 
      return -Math.round(parseFloat(val.replace(/[()]/g, '').replace(/,/g, '')));

    return Math.round(parseFloat(val.replace(/,/g, ''))) || 0;
  }

  return typeof val === 'number' ? Math.round(val) : 0;
}


function formatNumber(num) {
  return Number(num).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

  const sections = [];

  // Build section list from all data
  const sectionMap = new Map();
  for (const op of comparisondata) {
    let currentSection = '';
    for (const row of op.data) {
      if (row.length === 1) {
        currentSection = row[0];
        if (!sectionMap.has(currentSection)) sectionMap.set(currentSection, new Set());
      } else {
        sectionMap.get(currentSection).add(row[0]);
      }
    }
  }

  for (const [sectionName, ids] of sectionMap.entries()) {
    sections.push({
      name: sectionName,
      rows: Array.from(ids),
    });
  }

  // Calculate totals and averages
  const columnSums = Array(comparisondata.length * periodlabel.length).fill(0);
  const columnCounts = Array(comparisondata.length * periodlabel.length).fill(0);


  const getCellValue = (op, section, rowId) => {
    let currentSection = '';
    for (const row of op.data) {
      if (row.length === 1) {
        currentSection = row[0];
      } else if (currentSection === section && row[0] === rowId) {
        return row.slice(1);
      }
    }
    return Array(periodlabel.length).fill('');
  };



  useEffect(()=>{

      if(periodlabel.length == 1){
          setCOLUMN_WIDTH(300);
      }
      else if(periodlabel.length == 2){
          setCOLUMN_WIDTH(200);
      }
      else if(periodlabel.length > 2){
          setCOLUMN_WIDTH(100);
      }

  },[periodlabel.length])

    const periodCount = periodlabel.length;


const exportToExcel = () => {
  const table = document.getElementById("export-table");
  if (!table) {
    alert("Table not found!");
    return;
  }

  const worksheet = {};
  const merges = [];
  const range = { s: { c: 1000000, r: 1000000 }, e: { c: 0, r: 0 } };
  const cellMatrix = [];

  const rows = table.querySelectorAll("tr");

  let exportRowIndex = 0; // ✅ separate counter for exported rows

  rows.forEach((row) => {
    // ✅ Skip entire row if it has class "ignore"
    if (row.classList.contains("ignore")) return;

    const cells = row.querySelectorAll("th, td");
    let colIndex = 0;

    if (!cellMatrix[exportRowIndex]) cellMatrix[exportRowIndex] = [];

    cells.forEach((cell) => {
      // ✅ Skip individual cells with class "ignore"
      if (cell.classList.contains("ignore")) return;

      // Move to next free column
      while (cellMatrix[exportRowIndex][colIndex]) {
        colIndex++;
      }

      const clonedCell = cell.cloneNode(true);

      clonedCell.querySelectorAll(".ignore-excel").forEach((el) => {
          el.remove();
      });

      const cellText = clonedCell.innerText.trim();
      const colspan = parseInt(cell.getAttribute("colspan") || "1", 10);
      const rowspan = parseInt(cell.getAttribute("rowspan") || "1", 10);

      const cellRef = XLSX.utils.encode_cell({ r: exportRowIndex, c: colIndex });

      worksheet[cellRef] = { v: cellText };


      // Mark merged/occupied cells
      for (let r = 0; r < rowspan; r++) {
        for (let c = 0; c < colspan; c++) {
          const rr = exportRowIndex + r;
          const cc = colIndex + c;
          if (!cellMatrix[rr]) cellMatrix[rr] = [];
          cellMatrix[rr][cc] = true;
        }
      }

      if (rowspan > 1 || colspan > 1) {
        merges.push({
          s: { r: exportRowIndex, c: colIndex },
          e: { r: exportRowIndex + rowspan - 1, c: colIndex + colspan - 1 },
        });
      }

      range.s.r = Math.min(range.s.r, exportRowIndex);
      range.s.c = Math.min(range.s.c, colIndex);
      range.e.r = Math.max(range.e.r, exportRowIndex + rowspan - 1);
      range.e.c = Math.max(range.e.c, colIndex + colspan - 1);

      colIndex += colspan;
    });

    exportRowIndex++; // ✅ increment only for non-ignored rows
  });

  worksheet["!ref"] = XLSX.utils.encode_range(range);
  if (merges.length) worksheet["!merges"] = merges;

  worksheet["!freeze"] = { xSplit: "1", ySplit: "1" };

  // Fill blanks so Excel grid looks consistent
  for (let r = range.s.r; r <= range.e.r; r++) {
    for (let c = range.s.c; c <= range.e.c; c++) {
      const ref = XLSX.utils.encode_cell({ r, c });
      if (!worksheet[ref]) {
        // worksheet[ref] = { v: "", t: "s", z: "@" };
        continue;

      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "table_export (for uploading).xlsx");
};

const normalexportToExcel = () => {
  const table = document.getElementById("export-table");
  if (!table) {
    alert("Table not found!");
    return;
  }

  const worksheet = {};
  const merges = [];
  const range = { s: { c: 1000000, r: 1000000 }, e: { c: 0, r: 0 } };
  const cellMatrix = [];

  const rows = table.querySelectorAll("tr");

  let exportRowIndex = 0; // ✅ separate counter for exported rows

  rows.forEach((row) => {
    // ✅ Skip entire row if it has class "ignore"
    if (row.classList.contains("ignore2")) return;

    const cells = row.querySelectorAll("th, td");
    let colIndex = 0;

    if (!cellMatrix[exportRowIndex]) cellMatrix[exportRowIndex] = [];

    cells.forEach((cell) => {
      // ✅ Skip individual cells with class "ignore"
      if (cell.classList.contains("ignore2")) return;

      // Move to next free column
      while (cellMatrix[exportRowIndex][colIndex]) {
        colIndex++;
      }

      const clonedCell = cell.cloneNode(true);

      clonedCell.querySelectorAll(".ignore-excel").forEach((el) => {
          el.remove();
      });

      const cellText = clonedCell.innerText.trim();

      const colspan = parseInt(cell.getAttribute("colspan") || "1", 10);
      const rowspan = parseInt(cell.getAttribute("rowspan") || "1", 10);

      const cellRef = XLSX.utils.encode_cell({ r: exportRowIndex, c: colIndex });

      worksheet[cellRef] = { v: cellText };


      // Mark merged/occupied cells
      for (let r = 0; r < rowspan; r++) {
        for (let c = 0; c < colspan; c++) {
          const rr = exportRowIndex + r;
          const cc = colIndex + c;
          if (!cellMatrix[rr]) cellMatrix[rr] = [];
          cellMatrix[rr][cc] = true;
        }
      }

      if (rowspan > 1 || colspan > 1) {
        merges.push({
          s: { r: exportRowIndex, c: colIndex },
          e: { r: exportRowIndex + rowspan - 1, c: colIndex + colspan - 1 },
        });
      }

      range.s.r = Math.min(range.s.r, exportRowIndex);
      range.s.c = Math.min(range.s.c, colIndex);
      range.e.r = Math.max(range.e.r, exportRowIndex + rowspan - 1);
      range.e.c = Math.max(range.e.c, colIndex + colspan - 1);

      colIndex += colspan;
    });

    exportRowIndex++; // ✅ increment only for non-ignored rows
  });

  worksheet["!ref"] = XLSX.utils.encode_range(range);
  if (merges.length) worksheet["!merges"] = merges;

  worksheet["!freeze"] = { xSplit: "1", ySplit: "1" };

  // Fill blanks so Excel grid looks consistent
  for (let r = range.s.r; r <= range.e.r; r++) {
    for (let c = range.s.c; c <= range.e.c; c++) {
      const ref = XLSX.utils.encode_cell({ r, c });
      if (!worksheet[ref]) {
        // worksheet[ref] = { v: "", t: "s", z: "@" };
        continue;

      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "table_export (for normal usage).xlsx");
};



const UploadFile = async ()=>{

  setalertOpen(false);

  const fileData = new FormData();

  fileData.append("file", inputRef.current.files[0]);


  const res = await axios.post(`${url3}/api/research_new_period`,
    fileData,
  {
    headers: {
    "Content-Type": "multipart/form-data",
    },
  });

  const resp = res.data;

  if(resp.status == true){
    setperiodlabel([]);
    func();
    setbool(!bool);
    handleSelect3([]);
    handleSelect4([]);
    handleSelect5([]);
    handleSelect6([]);
  }
  else{
    setalertOpen(true);
    setalertType('error');
    setalertmessage(resp.message);
  }


  
  // console.log(inputRef.current.files[0]);

}

function formatstring(value) {
    if (!value) return "-";

    value = value.toString().trim();

    // ✅ If number is wrapped in brackets, return as-is
    if (value.startsWith("(") && value.endsWith(")")) {
        return value;
    }

    // Remove commas only for normal numbers
    let clean = value.replace(/,/g, '');

    if (isNaN(clean)) return value; // return original instead of 0

    return Number(clean).toLocaleString();
}





  return (
    <div  style={loading == 'loading' ? {height: '90vh'} : null}>
      <div className='fs-3 fw-bold text-center mt-2 mb-3' style={{color: "#000078"}}>
        Financial Sheet Data
      </div>
      {
        loading == 'loaded' ?
      <>
        <button className="btn btn-primary ms-1" onClick={() => setShowFilters(!showFilters)}> {showFilters ? "Close Filters" : "Open Filters"} </button>
        <button className="btn btn-primary ms-1" onClick={() => {setHiddenPeriods({})}}> Remove Period Filters </button>
        {showFilters && (
          <div className='col-12 card shadow'>
            <div className='col-12 col-lg-6 col-md-6 m-2'>
                <Select
                        options={group}
                        placeholder="Select Group"
                        value={selectedGroup}
                        onChange={handleSelect}
                        isSearchable={true}
                        // isMulti
                />
            </div>
            <div className='col-12 col-lg-6 col-md-6 m-2'>
                <Select
                        options={mainsector}
                        placeholder="Select Cluster"
                        value={selectedMainSector}
                        onChange={handleSelect2}
                        styles={customSelectStyles}
                        isSearchable={true}
                        // isMulti
                />
            </div>
            <div className='col-12 col-lg-6 col-md-6 m-2'>
                <Select
                        options={sector}
                        placeholder="Select Sector"
                        value={selectedSector}
                        onChange={handleSelect3}
                        styles={customSelectStyles}
                        isSearchable={true}
                        // isMulti
                />
            </div>
            <div className='col-12 col-lg-6 col-md-6 m-2'>
                <Select
                        options={scale}
                        placeholder="Select Rating Type"
                        value={selectedScale}
                        onChange={handleSelect4}
                        styles={customSelectStyles}
                        isSearchable={true}
                        isMulti
                />
            </div>
            <div className='col-12 col-lg-6 col-md-6 m-2'>
                <Select
                        options={opinion}
                        placeholder="Select Opinion"
                        value={selectedOpinion}
                        onChange={handleSelect5}
                        styles={customSelectStyles}
                        isSearchable={true}
                        closeMenuOnSelect={false}
                        isMulti
                />
            </div>
            <div className='col-12 col-lg-6 col-md-6 m-2'>
                <Select
                        options={period}
                        placeholder="Select Period"
                        value={selectedPeriod}
                        styles={customStyles}
                        onChange={handleSelect6}
                        isSearchable={true}
                        closeMenuOnSelect={false}
                        isMulti
                />
            </div>
          </div> )
        }
          {
              periodlabel.length > 0 &&
              <>
                  <div className='mt-3'>
                      <button className='btn btn-primary' onClick={exportToExcel} style={{ marginBottom: '10px' }}>
                      Export Table to Excel (For Uploading)
                      </button>
                      <button className='btn btn-success ms-1' onClick={normalexportToExcel} style={{ marginBottom: '10px' }}>
                      Export Table to Excel (For Normal Usage)
                      </button>
                  </div>
                  <div className='mt-2 col-6'>
                    <input className='form-control' type='file' accept=".xls,.xlsx" ref={inputRef} />
                    <div>
                       <Box className="mx-auto" sx={{ width: "98%" }}>
                          <Collapse in={alertopen}>
                            <Alert
                              severity={alertType}
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setalertOpen(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                              sx={{ mb: 2 }}
                            >
                              {AlertMessage}
                            </Alert>
                          </Collapse>
                        </Box>
                    </div>
                    <div>
                      <button className='btn btn-primary' onClick={()=>{UploadFile()}}>Save</button>
                    </div>
                  </div>
                  <div
                    className="card p-3 mt-4 d-flex align-items-center flex-nowrap"
                    style={{ width: "fit-content", whiteSpace: "nowrap" }}
                  >
                    <span><b>PACRA:</b> {pacra}</span><span className="ms-3"><b>VIS:</b> {vis}</span><span className="ms-3"><b>Other:</b> {other}</span>
                  </div>
                  <div className='card shadow col-12 mx-auto table-container' style={{ overflowX: 'auto', maxWidth: '100%', paddingBottom: '10px', maxHeight: '500px', overflowY: 'auto', overflowX: 'auto',  border: '1px solid #ccc'}}>
                      <table className="sticky-table" id='export-table'>
                          <thead>
                          <tr className='ignore2' hidden={true}>
                            <th colSpan={5}> <b>Note:</b>  Listed = 5 Unlisted = 7</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                            <th>{selectedGroup.label}</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                            <th>{selectedMainSector.label}</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                            <th>{selectedSector.label}</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                              <th className="">Opinion ID</th>
                              {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                {op.opinion_id}
                              </th>
                              ))}
                             
                              {periodlabel.map((k) => (
                                  <th className="ignore" style={{ minWidth: '120px', textAlign:"center !important", }}> </th>
                              ))}

                              {periodlabel.map((k) => (
                                  <th className="ignore" style={{ minWidth: '120px', textAlign:"center !important", }}></th>
                              ))}

                          </tr>
                          <tr className='ignore2' hidden={true}>
                              <th className="">Listed/Unlisted</th>
                              {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                {op.legal_status}
                              </th>
                              ))}

                              {periodlabel.map((k) => (
                                  <th className="ignore sticky-header-left-0" style={{ minWidth: '120px', textAlign:"center !important", }}></th>
                              ))}
                              {periodlabel.map((k) => (
                                  <th className="ignore sticky-header-left-0" style={{ minWidth: '120px', textAlign:"center !important", }}></th>
                              ))}

                          </tr>
                          <tr className='ignore'>
                            <th className="sticky-header-left-0">PACRA/VIS/Other</th>
                            {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                  {op.opinion} {op.legal_status == 5 ? '| Listed' : op.legal_status == 7 ? '| Unlisted' : null}
                              </th>
                              ))}

                                {periodlabel.map((label) => (
                              <th
                                  key={`total-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  
                                  style={{ minWidth: '120px', backgroundColor: '#d0d0d0', textAlign:"center !important", }}
                              >
                                
                              </th>
                              ))}
                              {periodlabel.map((label) => (
                              <th
                                  key={`avg-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  style={{ minWidth: '120px', backgroundColor: '#c0c0c0', textAlign:"center !important", }}
                              >
                                
                              </th>
                              ))}
                          </tr>
                          <tr hidden={true} className='ignore2'>
                            <th className="sticky-header-top-0 sticky-header-left-0">PACRA/VIS/Other</th>
                            {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                  {op.opinion}
                              </th>
                              ))}

                                {periodlabel.map((label) => (
                              <th
                                  key={`total-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  
                                  style={{ minWidth: '120px', backgroundColor: '#d0d0d0', textAlign:"center !important", }}
                              >
                              </th>
                              ))}
                              {periodlabel.map((label) => (
                              <th
                                  key={`avg-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  style={{ minWidth: '120px', backgroundColor: '#c0c0c0', textAlign:"center !important", }}
                              >
                              </th>
                              ))}
                          </tr>
                          <tr>
                            <th className="sticky-header-left-top-0"></th>
                            {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                  {op.name}
                              </th>
                              ))}

                                {periodlabel.map((label) => (
                              <th
                                  key={`total-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  rowSpan="2"
                                  style={{ minWidth: '120px', backgroundColor: '#d0d0d0', textAlign:"center !important", }}
                              >
                                  Total Sum {" "} <br /> {` ${label}`}
                              </th>
                              ))}
                              
                              {periodlabel.map((label) => (
                              <th
                                  key={`avg-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  rowSpan="2"
                                  style={{ minWidth: '120px', backgroundColor: '#c0c0c0', textAlign:"center !important", }}
                              >
                                  Average <br /> {` ${label}`} 
                              </th>
                              ))}
                          </tr>
                          <tr>

                              <th
                                  className="sticky-header-left-top-1 text-align"
                                  style={{
                                      width: `${COLUMN_WIDTH}px`,
                                      minWidth: `${COLUMN_WIDTH}px`,
                                      textAlign: "center"
                                  }}
                              >
                              </th>


                              {comparisondata.map((op) => {

                                  const visiblePeriods =
                                      getVisiblePeriods(op.name);

                                  return visiblePeriods.map((period) => (

                                      <th
                                          key={`${op.opinion_id}-${period}`}
                                          className="text-align sticky-header-top-1"
                                          style={{
                                              width: `${COLUMN_WIDTH}px`,
                                              minWidth: `${COLUMN_WIDTH}px`
                                          }}
                                      >

                                          <div
                                              style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  gap: "8px"
                                              }}
                                          >

                                              <span>
                                                  {period}
                                              </span>

                                              <button
                                                  type="button"
                                                  className="ignore-excel"
                                                  onClick={() =>
                                                      togglePeriod(
                                                          op.name,
                                                          period
                                                      )
                                                  }
                                                  style={{
                                                      border: "none",
                                                      background: "transparent",
                                                      cursor: "pointer",
                                                      color: "red",
                                                      fontWeight: "bold",
                                                      fontSize: "16px",
                                                      padding: "0"
                                                  }}
                                                  title={`Hide ${period} from ${op.name}`}
                                              >
                                                  ×
                                              </button>

                                          </div>

                                      </th>

                                  ));

                              })}

                          </tr>
                          </thead>

                      <tbody>

                      {sections.map((section) => (

                          <React.Fragment key={section.name}>

                              {/* SECTION HEADER */}
                              <tr className="ignore ignore2">

                                  <td
                                      colSpan={1}
                                      className="section-header ignore ignore2 sticky-header-left-0"
                                  >
                                      {section.name}
                                  </td>

                                  <td
                                      colSpan={
                                          comparisondata.reduce(
                                              (total, op) =>
                                                  total + getVisiblePeriods(op.name).length,
                                              0
                                          )
                                      }
                                      className="section-header ignore ignore2"
                                  >
                                  </td>

                                  <td
                                      className="section-header ignore ignore2"
                                      colSpan={periodlabel.length * 2}
                                  >
                                  </td>

                              </tr>


                              {/* DATA ROWS */}
                              {section.rows.map((rowId) => {

                                  return (

                                      <tr key={rowId}>

                                          {/* ROW NAME */}
                                          <td
                                              className="sticky-header-left-0"
                                              style={{
                                                  fontWeight: "bold",
                                                  minWidth: "400px",
                                                  textAlign: "left"
                                              }}
                                          >
                                              {rowId}
                                          </td>


                                          {/* ================================================= */}
                                          {/* OPINION DATA COLUMNS                             */}
                                          {/* ================================================= */}

                                          {comparisondata.map((op) => {

                                              const values = getCellValue(
                                                  op,
                                                  section.name,
                                                  rowId
                                              );

                                              const visiblePeriods =
                                                  getVisiblePeriods(op.name);

                                              return visiblePeriods.map((period) => {

                                                  const originalIndex =
                                                      periodlabel.indexOf(period);

                                                  const val =
                                                      values[originalIndex];

                                                  return (

                                                      <td
                                                          key={`${op.opinion_id}-${period}-${rowId}`}
                                                          className="text-align"
                                                          style={{
                                                              width: `${COLUMN_WIDTH}px`,
                                                              minWidth: `${COLUMN_WIDTH}px`,
                                                              textAlign: "center"
                                                          }}
                                                      >
                                                          {
                                                              val == 0
                                                                  ? "-"
                                                                  : val == ""
                                                                  ? " "
                                                                  : val == "0"
                                                                  ? "-"
                                                                  : formatstring(val)
                                                          }
                                                      </td>

                                                  );

                                              });

                                          })}


                                          {/* ================================================= */}
                                          {/* TOTAL COLUMNS                                      */}
                                          {/* ================================================= */}

                                          {periodlabel.map((period) => {

                                              const valuesForPeriod = [];

                                              comparisondata.forEach((op) => {

                                                  /*
                                                  * If this particular opinion has hidden
                                                  * this particular period, don't include it.
                                                  */
                                                  if (
                                                      isPeriodHidden(
                                                          op.name,
                                                          period
                                                      )
                                                  ) {
                                                      return;
                                                  }

                                                  const values = getCellValue(
                                                      op,
                                                      section.name,
                                                      rowId
                                                  );

                                                  const originalIndex =
                                                      periodlabel.indexOf(period);

                                                  const rawVal =
                                                      values[originalIndex];

                                                  valuesForPeriod.push(
                                                      normalizeValue(rawVal)
                                                  );

                                              });


                                              const total =
                                                  valuesForPeriod.reduce(
                                                      (a, b) => a + b,
                                                      0
                                                  );


                                              return (

                                                  <td
                                                      key={`total-${period}-${rowId}`}
                                                      className="text-align ignore"
                                                      style={{
                                                          textAlign: "center"
                                                      }}
                                                  >
                                                      {formatNumber(total)}
                                                  </td>

                                              );

                                          })}


                                          {/* ================================================= */}
                                          {/* AVERAGE COLUMNS                                    */}
                                          {/* ================================================= */}

                                          {periodlabel.map((period) => {

                                              const valuesForPeriod = [];

                                              comparisondata.forEach((op) => {

                                                  /*
                                                  * Don't include hidden opinion/period
                                                  * combinations in the average.
                                                  */
                                                  if (
                                                      isPeriodHidden(
                                                          op.name,
                                                          period
                                                      )
                                                  ) {
                                                      return;
                                                  }

                                                  const values = getCellValue(
                                                      op,
                                                      section.name,
                                                      rowId
                                                  );

                                                  const originalIndex =
                                                      periodlabel.indexOf(period);

                                                  const rawVal =
                                                      values[originalIndex];

                                                  valuesForPeriod.push(
                                                      normalizeValue(rawVal)
                                                  );

                                              });


                                              const avg =
                                                  valuesForPeriod.length > 0
                                                      ? valuesForPeriod.reduce(
                                                          (a, b) => a + b,
                                                          0
                                                      ) / valuesForPeriod.length
                                                      : 0;


                                              return (

                                                  <td
                                                      key={`avg-${period}-${rowId}`}
                                                      className="text-align ignore"
                                                      style={{
                                                          textAlign: "center"
                                                      }}
                                                  >
                                                      {formatNumber(avg)}
                                                  </td>

                                              );

                                          })}

                                      </tr>

                                  );

                              })}

                          </React.Fragment>

                      ))}

                      </tbody>
                    </table>
                  </div>
              </>
          }
        
      </>
      :
      (<div className="mt-5 mx-auto" style={{ width: "fit-content" }}>
              <div class="wrapper" id="loader2">
                <svg
                  class="hourglass"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 120 206"
                  preserveAspectRatio="none"
                >
                  <path
                    class="middle"
                    d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
                  />
                  <path
                    class="outer"
                    d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
                  />
                </svg>
              </div>
            </div>)

        
      }
      
    </div>
  )
}